import { ButtonProps } from "@mui/material";
import styled from "styled-components";

export const Content = styled.div`
  padding: 30px;
  padding-bottom: 0px;
  margin-top: 100px;
  width: 100%;
  background-color: #f5f5f5;
`;

export const ContainerBtn: any = styled.button<ButtonProps>`
  backdrop-filter: blur(10.2528px);
  display: flex;
  font-family: Inter;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  width: 520px;
  height: 40px;
  background-color: ${(props: any) => props.backgroundColor};
  border: none;
  color: white;
  :hover {
    cursor: pointer;
  }
`;

export const Container = styled.div`
  width: 98%;
  background-color: #ffffff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  margin-bottom: 20px;
`;

export const ContainerSub = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 14px;
  border-radius: 16px;
  margin-bottom: 32px;
  border: 1px solid #ececec;
`;

export const ContainerSubHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerHeaderList = styled.div`
  width: 100%;
  display: flex;
  background-color: #f2f4f8;
  padding: 8px 16px;
  border-radius: 12px 12px 0px 0px;
  margin-bottom: 32px;
  border: 1px solid #ececec;
  margin: 15px 0 0 0;
`;

export const ContainerHeaderListInfo = styled.div`
  width: 100%;
  display: flex;
  background-color: #ffffff;
  padding: 12px 16px;
  border-radius: 0px 0px 12px 12px;
  margin-bottom: 32px;
  border-right: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  border-left: 1px solid #ececec;
  border-top: none;
`;

export const ContainerHeaderListInfo2 = styled.div`
  width: 100%;
  display: flex;
  background-color: #ffffff;
  padding: 8px 16px;
  border-right: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  border-left: 1px solid #ececec;
  border-top: none;
`;

export const TitleHeaderList = styled.h2`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  color: #646363;
  white-space: nowrap;
`;

export const TitleHeaderListInfo = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #424248;
  white-space: nowrap;
`;

export const BottomTable = styled.div`
  border-radius: 3px;
  display: flex;
  font-size: 16px;
  border-radius: 0.5rem;
  margin: 15px 0 0 0;
  background-color: #f2f4f8;
  width: 100%;
  padding: 50px;
  justify-content: center;
`;

export const Title = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  margin-bottom: 16px;

  color: rgba(0, 0, 0, 0.87);
`;

export const TitleSub = styled.h2`
  width: 189px;
  height: 24px;
  gap: 0px;
  opacity: 0px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 24.2px;
  text-align: left;
  white-space: nowrap;
`;

export const TitleTwoSub = styled.h3`
  width: 179px;
  height: 19px;
  gap: 0px;
  opacity: 0.9px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: center;
`;

export const TextP = styled.p`
  display: flex;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  letter-spacing: -0.01em;
  text-align: center;
`;

export const HeaderTable = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

export const Text: any = styled.p`
  width: 189px;
  height: 24px;
  gap: 0px;
  white-space: nowrap;
  opacity: 0.9px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 24.2px;
`;
